var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.7,56.3l5.1-43.4c0.2-1.3-0.8-2.5-2.1-2.7C89.4,10,88.2,11,88,12.3l-5.2,44.1c-0.1,0.5,0,1,0.2,1.4 c3.2,6.4,4.9,13.7,4.9,20.9V80c0,4.4-3.6,8-8,8h-7.5c-1.5,0-3.1-0.3-4.4-1c-5.6-2.8-12.2-2.8-17.7,0c-1.4,0.7-2.9,1-4.4,1H21.7 C18,88,15,85,15,81.3c0-0.9,0.8-1.5,1.5-1.5H23c2.2,0,4.3-0.7,6.1-1.9c5.2-3.5,18.4-12.7,26-18c4.2-2.9,6.6-7.6,6.6-12.6V12.6 c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4v34.7c0,3.4-1.7,6.7-4.5,8.7c-7.6,5.3-20.9,14.4-26,18c-1,0.7-2.1,1.1-3.3,1.1h-6.5 c-3.5,0-6.3,2.8-6.3,6.3c0,6.3,5.2,11.5,11.5,11.5H46c2.3,0,4.5-0.6,6.6-1.6c4.2-2.1,9.2-2.1,13.4,0c2,1,4.3,1.6,6.6,1.6H80 c7.1,0,12.8-5.8,12.8-12.8v-1.3C92.8,71,91.1,63.2,87.7,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.5,68.7c0.5,0.6,2.1,1.4,3.4,0.1c0,0,0,0,0.1,0c3.9-3.9,3.7-10.1,0-13.8h0c-0.9-1-2.5-1-3.4,0 c-0.9,0.9-0.9,2.5,0,3.4c1.9,1.9,1.9,5,0,7C69.6,66.3,69.6,67.8,70.5,68.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyArea);
export default __webpack_public_path__ + "static/media/Body-Area.b9246b9787d95a529c388432ddc6b634.svg";
export { ForwardRef as ReactComponent };